<template>
    <div>
        <header-bar></header-bar>
        <main role='main' class='main container-fluid'>
            <slot></slot>
        </main>
        <footer-bar></footer-bar>
    </div>
</template>

<script>
    import HeaderBar from './HeaderBar';
    import FooterBar from './FooterBar';

    export default {
        name: 'standard',
        components: {
            FooterBar,
            HeaderBar
        }
    }
</script>

<style>
    html {
        position: relative;
        min-height: 100%;
    }
    body {
        background-color: #f7f7f7;
    }
    .main {
        min-height: 600px;
    }
</style>





// WEBPACK FOOTER //
// src/components/layout/Standard.vue